import { createRouter, createWebHistory } from 'vue-router'

import HomeView from '../views/Home.vue'
import DsoContracts from "@/views/DsoContracts.vue";
import DsoContractForm from "@/views/DsoContractForm.vue";
import DsoReplace from "@/views/DsoCompaniesReplace.vue";
import DsoCompany from "@/views/DsoCompanies.vue";
import DsoCompanyForm from "@/views/DsoCompanyForm.vue";
import EdaConnectionForm from "@/views/EdaConnectionForm.vue";
import EdaConnections from "@/views/EdaConnections.vue";
import ViewMeteringpoints from "@/views/ViewMeteringpoints.vue";
import ViewMeteringpointsCm from "@/views/ViewMeteringpointsCm.vue";
import ViewMeteringPointsAnalysis from "@/views/ViewMeteringPointAnalysis.vue";
import ViewMeteringPointsAnalysis1 from "@/views/ViewMeteringPointAnalysis1.vue";
import ViewStatistics from "@/views/ViewStatistics.vue";
import ViewAllMaintainers from "@/views/ViewAllMaintainers.vue";
import ViewExportOdoo from "@/views/ViewExportOdoo.vue";
import CommunityPublicData from "@/views/CommunityPublicData.vue";
import CommunityPublicDataForm from "@/views/CommunityPublicDataForm.vue";
import CommunityProviders from '@/views/CommunityProviders.vue';
import CommunityProviderForm from '@/views/CommunityProviderForm.vue';
import CommunityCompanies from '@/views/CommunityCompanies.vue';
import CommunityCompanyForm from '@/views/CommunityCompanyForm.vue';
import CommunityDetailForm from '@/views/CommunityDetailForm.vue';
import NotificationContacts from "@/views/NotificationContacts.vue";
import NotificationContactForm from "@/views/NotificationContactForm.vue";
import ViewCommunityAnalysisBadMeteringPoints from "@/views/ViewCommunityAnalysisBadMeteringPoints.vue"
import ViewCommunityRequestPodlist from "@/views/ViewCommunityRequestPodlist.vue"
import ViewCommunityPodlistViewer from "@/views/ViewCommunityPodlistViewer.vue"
import ViewBillrunsDashboard from "@/views/ViewBillrunsDashboard.vue";
import ViewBillrunsDetails from "@/views/ViewBillrunsDetails.vue";
import ViewBillrunsAnalysis from "@/views/ViewBillrunsAnalysis.vue";
import XpMessengerCreatePartner from "@/views/XpMessengerCreatePartner.vue";
import XpMessengerDashboard from "@/views/XpMessengerDashboard.vue";
import ViewCamtPreview from "@/views/ViewCamtPreview.vue";
import ViewExportEnergyDump from "@/views/ViewExportEnergyDump.vue";
import ViewEnergyDataCleanup from "@/views/ViewEnergyDataCleanup.vue";
import ViewEnergyDataHistory from "@/views/ViewEnergyDataHistory.vue";
import ViewSumsReport from "@/views/ViewSumsReport.vue";
import ViewStatisticsCommunity from "@/views/ViewStatisticsCommunity.vue";
import ViewEnergyDataRequests from "@/views/ViewEnergyDataRequests.vue";

const routes = [
  { // keep the home route at first
    path: '/',
    name: 'home',
    meta: { titleKey: 'home'},
    component: HomeView,
  },
  {
    path: '/dsoContracts',
    name: 'dsoContracts',
    meta: { titleKey: 'dsoContracts'},
    component: DsoContracts,
  },
  {
    path: '/createDsoContracts/:id?',
    name: 'createDsoContracts',
    meta: { titleKey: 'createDsoContracts'},
    component: DsoContractForm,
  },
  {
    path: '/replaceDsoCompanies',
    name: 'replaceDsoCompanies',
    meta: { titleKey: 'replaceDsoCompanies'},
    component: DsoReplace
  },
  {
    path: '/dsoCompanies',
    name: 'dsoCompanies',
    meta: { titleKey: 'dsoCompanies'},
    component: DsoCompany
  },
  {
    path: '/dsoCompanyForm/:id?',
    name: 'dsoCompanyForm',
    meta: { titleKey: 'dsoCompanyForm'},
    component: DsoCompanyForm
  },
  {
    path: '/communityProviders',
    name: 'communityProviders',
    meta: { titleKey: 'communityProviders.title'},
    component: CommunityProviders
  },
  {
    path: '/communityProviderForm/:id?',
    name: 'communityProviderForm',
    meta: { titleKey: 'communityProviders.title'},
    component: CommunityProviderForm
  },
  {
    path: '/communityCompanies',
    name: 'communityCompanies',
    meta: { titleKey: 'communityCompanies.title'},
    component: CommunityCompanies
  },
  {
    path: '/communityCompanyForm/:ecn',
    name: 'communityCompanyForm',
    meta: { titleKey: 'communityCompanies.title'},
    component: CommunityCompanyForm
  },
  {
    path: '/communityDetailForm/:ecid',
    name: 'communityDetailForm',
    meta: { titleKey: 'communityDetail.title'},
    component: CommunityDetailForm
  },
  {
    path: '/communities',
    name: 'communities',
    meta: { titleKey: 'publicCommunityInformation'},
    component: CommunityPublicData
  },
  {
    path: '/communityForm/:id?',
    name: 'communityForm',
    meta: { titleKey: 'publicCommunityInformationForm'},
    component: CommunityPublicDataForm
  },
  {
    path: '/notificationContacts/:ecid?',
    name: 'notificationContacts',
    meta: { titleKey: 'notificationContacts' },
    component: NotificationContacts
  },
  {
    path: '/notificationContactForm/:ecid?/:contactId?',
    name: 'notificationContactForm',
    meta: { titleKey: 'notificationContactForm' },
    component: NotificationContactForm
  },
  {
    path: '/edaConnections',
    name: 'edaConnections',
    meta: { titleKey: 'edaConnections'},
    component: EdaConnections
  },
  {
    path: '/energyDataRequests',
    name: 'energyDataRequests',
    meta: { titleKey: 'energyDataRequests'},
    component: ViewEnergyDataRequests
  },
  {
    path: '/edaConnectionForm/:id?',
    name: 'edaConnectionForm',
    meta: { titleKey: 'edaConnectionForm'},
    component: EdaConnectionForm
  },
  {
    path: '/meteringPoints',
    name: 'meteringPoints',
    meta: { titleKey: 'meteringPoints'},
    component: ViewMeteringpoints
  },
  {
    path: '/meteringPointsCm',
    name: 'meteringPointsCm',
    meta: { titleKey: 'meteringPointsCm'},
    component: ViewMeteringpointsCm
  },
  {
    path: '/energyDataCleanup',
    name: 'energyDataCleanup',
    meta: {titleKey: 'energyDataCleanup.title'},
    component: ViewEnergyDataCleanup,
  },
  {
    path: '/energyDataHistory',
    name: 'energyDataHistory',
    meta: { titleKey: 'energyDataHistory.title'},
    component: ViewEnergyDataHistory
  },
  {
    path: '/sumsReport',
    name: 'sumsReport',
    meta: { titleKey: 'sumsReport.title'},
    component: ViewSumsReport
  },
  {
    path: '/meteringPoints/analysis',
    name: 'meteringPointsAnalysis',
    meta: { titleKey: 'analysis'},
    component: ViewMeteringPointsAnalysis
  },
  {
    path: '/meteringPoints/analysis1',
    name: 'meteringPointsAnalysis1',
    meta: { titleKey: 'analysis'},
    component: ViewMeteringPointsAnalysis1
  },
  {
    path: '/communities/:ecid/statstics',
    name: 'ViewStatisticsCommunity',
    meta: { titleKey: 'communityAnalysis'},
    component: ViewStatisticsCommunity
  },
  {
    path: '/statistics',
    name: 'ViewStatistics',
    meta: { titleKey: 'statistics'},
    component: ViewStatistics
  },
  {
    path: '/maintainers',
    name: 'ViewAllMaintainers',
    meta: { titleKey: 'maintainers'},
    component: ViewAllMaintainers
  },
  {
    path: '/exports/odoo',
    name: 'ViewExportOdoo',
    meta: { titleKey: 'export-odoo'},
    component: ViewExportOdoo
  },


  {
    path: '/communities/analysis/badMeteringPoints',
    name: 'ViewCommunityAnalysisBadMeteringPoints',
    meta: { titleKey: 'maintainers'},
    component: ViewCommunityAnalysisBadMeteringPoints
  },
  {
    path: '/communities/ecpodlist',
    name: 'ViewCommunityRequestPodlist',
    meta: { titleKey: 'maintainers'},
    component: ViewCommunityRequestPodlist
  },
  {
    path: '/communities/podlistViewer',
    name: 'ViewCommunityPodlistViewer',
    meta: { titleKey: 'maintainers'},
    component: ViewCommunityPodlistViewer
  },
  {
    path: '/billRuns/dashboard',
    name: 'billrunsDashboard',
    meta: { titleKey: 'billrunsDashboard.dashboard' },
    component: ViewBillrunsDashboard
  },
  {
    path: '/billRuns/details',
    name: 'billrunsDetails',
    meta: { titleKey: 'billrunsDetails.title' },
    component: ViewBillrunsDetails
  },
  {
    path: '/billRuns/analysis',
    name: 'billrunsAnalysis',
    meta: { titleKey: 'billrunsAnalysis.title' },
    component: ViewBillrunsAnalysis
  },

  {
    path: '/messenger/dashboard',
    name: 'dashboard',
    meta: { titleKey: 'xp-messenger.dashboard.title'},
    component: XpMessengerDashboard
  },
  {
    path: '/messenger/create-partner',
    name: 'createPartner',
    meta: { titleKey: 'xp-messenger.partner.create'},
    component: XpMessengerCreatePartner
  },


  {
    path: '/misc/camt-preview',
    name: 'ViewCamtPreview',
    meta: { titleKey: 'camt-preview'},
    component: ViewCamtPreview
  },
  {
    path: '/exports/energyDump',
    name: 'ViewExportEnergyDump',
    meta: { titleKey: 'energyDump'},
    component: ViewExportEnergyDump
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

function hasQueryParam(route,param) {
  return Object.keys(route.query).includes(param);
}

export default router
